import { render } from "./EbmSettingSkeleton.vue?vue&type=template&id=7dbd1b2c&scoped=true"
import script from "./EbmSettingSkeleton.vue?vue&type=script&lang=js"
export * from "./EbmSettingSkeleton.vue?vue&type=script&lang=js"

import "./EbmSettingSkeleton.vue?vue&type=style&index=0&id=7dbd1b2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbd1b2c"]])

export default __exports__